import Language from 'types/LanguageEnum';

export enum DictionaryName {
  /** Simplified Chinese - Pinyin (zh-CN) */
  PINYIN_SIMPLIFIED = 'PINYIN_SIMPLIFIED',

  /** Traditional Chinese - Pinyin (zh-HK, zh-TW via Zhuyin-to-Pinyin conversion) */
  PINYIN_TRADITIONAL = 'PINYIN_TRADITIONAL',

  /** Traditional Chinese - Cangjie (zh-HK, zh-TW) */
  CANGJIE_TRADITIONAL = 'CANGJIE_TRADITIONAL',

}

export type DictionaryLanguage = Language.ZH_CN | Language.ZH_TW | Language.ZH_HK;
